/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var extproto_ext_pb = require('../../../../../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.rbac.options.gloo.solo.io.ExtensionSettings', null, global);
goog.exportSymbol('proto.rbac.options.gloo.solo.io.JWTPrincipal', null, global);
goog.exportSymbol('proto.rbac.options.gloo.solo.io.JWTPrincipal.ClaimMatcher', null, global);
goog.exportSymbol('proto.rbac.options.gloo.solo.io.Permissions', null, global);
goog.exportSymbol('proto.rbac.options.gloo.solo.io.Policy', null, global);
goog.exportSymbol('proto.rbac.options.gloo.solo.io.Principal', null, global);
goog.exportSymbol('proto.rbac.options.gloo.solo.io.Settings', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rbac.options.gloo.solo.io.Settings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rbac.options.gloo.solo.io.Settings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.rbac.options.gloo.solo.io.Settings.displayName = 'proto.rbac.options.gloo.solo.io.Settings';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rbac.options.gloo.solo.io.Settings.prototype.toObject = function(opt_includeInstance) {
  return proto.rbac.options.gloo.solo.io.Settings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rbac.options.gloo.solo.io.Settings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Settings.toObject = function(includeInstance, msg) {
  var f, obj = {
    requireRbac: jspb.Message.getFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rbac.options.gloo.solo.io.Settings}
 */
proto.rbac.options.gloo.solo.io.Settings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rbac.options.gloo.solo.io.Settings;
  return proto.rbac.options.gloo.solo.io.Settings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rbac.options.gloo.solo.io.Settings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rbac.options.gloo.solo.io.Settings}
 */
proto.rbac.options.gloo.solo.io.Settings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequireRbac(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rbac.options.gloo.solo.io.Settings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rbac.options.gloo.solo.io.Settings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rbac.options.gloo.solo.io.Settings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Settings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequireRbac();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool require_rbac = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.rbac.options.gloo.solo.io.Settings.prototype.getRequireRbac = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.rbac.options.gloo.solo.io.Settings.prototype.setRequireRbac = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rbac.options.gloo.solo.io.ExtensionSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.rbac.options.gloo.solo.io.ExtensionSettings.displayName = 'proto.rbac.options.gloo.solo.io.ExtensionSettings';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.rbac.options.gloo.solo.io.ExtensionSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rbac.options.gloo.solo.io.ExtensionSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    disable: jspb.Message.getFieldWithDefault(msg, 1, false),
    policiesMap: (f = msg.getPoliciesMap()) ? f.toObject(includeInstance, proto.rbac.options.gloo.solo.io.Policy.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rbac.options.gloo.solo.io.ExtensionSettings}
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rbac.options.gloo.solo.io.ExtensionSettings;
  return proto.rbac.options.gloo.solo.io.ExtensionSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rbac.options.gloo.solo.io.ExtensionSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rbac.options.gloo.solo.io.ExtensionSettings}
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisable(value);
      break;
    case 2:
      var value = msg.getPoliciesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.rbac.options.gloo.solo.io.Policy.deserializeBinaryFromReader, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rbac.options.gloo.solo.io.ExtensionSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rbac.options.gloo.solo.io.ExtensionSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPoliciesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.rbac.options.gloo.solo.io.Policy.serializeBinaryToWriter);
  }
};


/**
 * optional bool disable = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.prototype.getDisable = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.rbac.options.gloo.solo.io.ExtensionSettings.prototype.setDisable = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * map<string, Policy> policies = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.rbac.options.gloo.solo.io.Policy>}
 */
proto.rbac.options.gloo.solo.io.ExtensionSettings.prototype.getPoliciesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.rbac.options.gloo.solo.io.Policy>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.rbac.options.gloo.solo.io.Policy));
};


proto.rbac.options.gloo.solo.io.ExtensionSettings.prototype.clearPoliciesMap = function() {
  this.getPoliciesMap().clear();
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rbac.options.gloo.solo.io.Policy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rbac.options.gloo.solo.io.Policy.repeatedFields_, null);
};
goog.inherits(proto.rbac.options.gloo.solo.io.Policy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.rbac.options.gloo.solo.io.Policy.displayName = 'proto.rbac.options.gloo.solo.io.Policy';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rbac.options.gloo.solo.io.Policy.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.toObject = function(opt_includeInstance) {
  return proto.rbac.options.gloo.solo.io.Policy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rbac.options.gloo.solo.io.Policy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Policy.toObject = function(includeInstance, msg) {
  var f, obj = {
    principalsList: jspb.Message.toObjectList(msg.getPrincipalsList(),
    proto.rbac.options.gloo.solo.io.Principal.toObject, includeInstance),
    permissions: (f = msg.getPermissions()) && proto.rbac.options.gloo.solo.io.Permissions.toObject(includeInstance, f),
    nestedClaimDelimiter: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rbac.options.gloo.solo.io.Policy}
 */
proto.rbac.options.gloo.solo.io.Policy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rbac.options.gloo.solo.io.Policy;
  return proto.rbac.options.gloo.solo.io.Policy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rbac.options.gloo.solo.io.Policy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rbac.options.gloo.solo.io.Policy}
 */
proto.rbac.options.gloo.solo.io.Policy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rbac.options.gloo.solo.io.Principal;
      reader.readMessage(value,proto.rbac.options.gloo.solo.io.Principal.deserializeBinaryFromReader);
      msg.addPrincipals(value);
      break;
    case 2:
      var value = new proto.rbac.options.gloo.solo.io.Permissions;
      reader.readMessage(value,proto.rbac.options.gloo.solo.io.Permissions.deserializeBinaryFromReader);
      msg.setPermissions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNestedClaimDelimiter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rbac.options.gloo.solo.io.Policy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rbac.options.gloo.solo.io.Policy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Policy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrincipalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.rbac.options.gloo.solo.io.Principal.serializeBinaryToWriter
    );
  }
  f = message.getPermissions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.rbac.options.gloo.solo.io.Permissions.serializeBinaryToWriter
    );
  }
  f = message.getNestedClaimDelimiter();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated Principal principals = 1;
 * @return {!Array<!proto.rbac.options.gloo.solo.io.Principal>}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.getPrincipalsList = function() {
  return /** @type{!Array<!proto.rbac.options.gloo.solo.io.Principal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.rbac.options.gloo.solo.io.Principal, 1));
};


/** @param {!Array<!proto.rbac.options.gloo.solo.io.Principal>} value */
proto.rbac.options.gloo.solo.io.Policy.prototype.setPrincipalsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.rbac.options.gloo.solo.io.Principal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.rbac.options.gloo.solo.io.Principal}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.addPrincipals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.rbac.options.gloo.solo.io.Principal, opt_index);
};


proto.rbac.options.gloo.solo.io.Policy.prototype.clearPrincipalsList = function() {
  this.setPrincipalsList([]);
};


/**
 * optional Permissions permissions = 2;
 * @return {?proto.rbac.options.gloo.solo.io.Permissions}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.getPermissions = function() {
  return /** @type{?proto.rbac.options.gloo.solo.io.Permissions} */ (
    jspb.Message.getWrapperField(this, proto.rbac.options.gloo.solo.io.Permissions, 2));
};


/** @param {?proto.rbac.options.gloo.solo.io.Permissions|undefined} value */
proto.rbac.options.gloo.solo.io.Policy.prototype.setPermissions = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.rbac.options.gloo.solo.io.Policy.prototype.clearPermissions = function() {
  this.setPermissions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.hasPermissions = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string nested_claim_delimiter = 3;
 * @return {string}
 */
proto.rbac.options.gloo.solo.io.Policy.prototype.getNestedClaimDelimiter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.rbac.options.gloo.solo.io.Policy.prototype.setNestedClaimDelimiter = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rbac.options.gloo.solo.io.Principal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rbac.options.gloo.solo.io.Principal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.rbac.options.gloo.solo.io.Principal.displayName = 'proto.rbac.options.gloo.solo.io.Principal';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rbac.options.gloo.solo.io.Principal.prototype.toObject = function(opt_includeInstance) {
  return proto.rbac.options.gloo.solo.io.Principal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rbac.options.gloo.solo.io.Principal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Principal.toObject = function(includeInstance, msg) {
  var f, obj = {
    jwtPrincipal: (f = msg.getJwtPrincipal()) && proto.rbac.options.gloo.solo.io.JWTPrincipal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rbac.options.gloo.solo.io.Principal}
 */
proto.rbac.options.gloo.solo.io.Principal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rbac.options.gloo.solo.io.Principal;
  return proto.rbac.options.gloo.solo.io.Principal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rbac.options.gloo.solo.io.Principal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rbac.options.gloo.solo.io.Principal}
 */
proto.rbac.options.gloo.solo.io.Principal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rbac.options.gloo.solo.io.JWTPrincipal;
      reader.readMessage(value,proto.rbac.options.gloo.solo.io.JWTPrincipal.deserializeBinaryFromReader);
      msg.setJwtPrincipal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rbac.options.gloo.solo.io.Principal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rbac.options.gloo.solo.io.Principal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rbac.options.gloo.solo.io.Principal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Principal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJwtPrincipal();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.rbac.options.gloo.solo.io.JWTPrincipal.serializeBinaryToWriter
    );
  }
};


/**
 * optional JWTPrincipal jwt_principal = 1;
 * @return {?proto.rbac.options.gloo.solo.io.JWTPrincipal}
 */
proto.rbac.options.gloo.solo.io.Principal.prototype.getJwtPrincipal = function() {
  return /** @type{?proto.rbac.options.gloo.solo.io.JWTPrincipal} */ (
    jspb.Message.getWrapperField(this, proto.rbac.options.gloo.solo.io.JWTPrincipal, 1));
};


/** @param {?proto.rbac.options.gloo.solo.io.JWTPrincipal|undefined} value */
proto.rbac.options.gloo.solo.io.Principal.prototype.setJwtPrincipal = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.rbac.options.gloo.solo.io.Principal.prototype.clearJwtPrincipal = function() {
  this.setJwtPrincipal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.rbac.options.gloo.solo.io.Principal.prototype.hasJwtPrincipal = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rbac.options.gloo.solo.io.JWTPrincipal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.rbac.options.gloo.solo.io.JWTPrincipal.displayName = 'proto.rbac.options.gloo.solo.io.JWTPrincipal';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.toObject = function(opt_includeInstance) {
  return proto.rbac.options.gloo.solo.io.JWTPrincipal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rbac.options.gloo.solo.io.JWTPrincipal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.toObject = function(includeInstance, msg) {
  var f, obj = {
    claimsMap: (f = msg.getClaimsMap()) ? f.toObject(includeInstance, undefined) : [],
    provider: jspb.Message.getFieldWithDefault(msg, 2, ""),
    matcher: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rbac.options.gloo.solo.io.JWTPrincipal}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rbac.options.gloo.solo.io.JWTPrincipal;
  return proto.rbac.options.gloo.solo.io.JWTPrincipal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rbac.options.gloo.solo.io.JWTPrincipal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rbac.options.gloo.solo.io.JWTPrincipal}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getClaimsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvider(value);
      break;
    case 3:
      var value = /** @type {!proto.rbac.options.gloo.solo.io.JWTPrincipal.ClaimMatcher} */ (reader.readEnum());
      msg.setMatcher(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rbac.options.gloo.solo.io.JWTPrincipal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rbac.options.gloo.solo.io.JWTPrincipal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getProvider();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMatcher();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.ClaimMatcher = {
  EXACT_STRING: 0,
  BOOLEAN: 1,
  LIST_CONTAINS: 2
};

/**
 * map<string, string> claims = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.getClaimsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.clearClaimsMap = function() {
  this.getClaimsMap().clear();
};


/**
 * optional string provider = 2;
 * @return {string}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.getProvider = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.setProvider = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ClaimMatcher matcher = 3;
 * @return {!proto.rbac.options.gloo.solo.io.JWTPrincipal.ClaimMatcher}
 */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.getMatcher = function() {
  return /** @type {!proto.rbac.options.gloo.solo.io.JWTPrincipal.ClaimMatcher} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.rbac.options.gloo.solo.io.JWTPrincipal.ClaimMatcher} value */
proto.rbac.options.gloo.solo.io.JWTPrincipal.prototype.setMatcher = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rbac.options.gloo.solo.io.Permissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rbac.options.gloo.solo.io.Permissions.repeatedFields_, null);
};
goog.inherits(proto.rbac.options.gloo.solo.io.Permissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.rbac.options.gloo.solo.io.Permissions.displayName = 'proto.rbac.options.gloo.solo.io.Permissions';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rbac.options.gloo.solo.io.Permissions.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rbac.options.gloo.solo.io.Permissions.prototype.toObject = function(opt_includeInstance) {
  return proto.rbac.options.gloo.solo.io.Permissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rbac.options.gloo.solo.io.Permissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Permissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathPrefix: jspb.Message.getFieldWithDefault(msg, 1, ""),
    methodsList: jspb.Message.getRepeatedField(msg, 2)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rbac.options.gloo.solo.io.Permissions}
 */
proto.rbac.options.gloo.solo.io.Permissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rbac.options.gloo.solo.io.Permissions;
  return proto.rbac.options.gloo.solo.io.Permissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rbac.options.gloo.solo.io.Permissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rbac.options.gloo.solo.io.Permissions}
 */
proto.rbac.options.gloo.solo.io.Permissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPathPrefix(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMethods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rbac.options.gloo.solo.io.Permissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rbac.options.gloo.solo.io.Permissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rbac.options.gloo.solo.io.Permissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rbac.options.gloo.solo.io.Permissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathPrefix();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string path_prefix = 1;
 * @return {string}
 */
proto.rbac.options.gloo.solo.io.Permissions.prototype.getPathPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.rbac.options.gloo.solo.io.Permissions.prototype.setPathPrefix = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string methods = 2;
 * @return {!Array<string>}
 */
proto.rbac.options.gloo.solo.io.Permissions.prototype.getMethodsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.rbac.options.gloo.solo.io.Permissions.prototype.setMethodsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.rbac.options.gloo.solo.io.Permissions.prototype.addMethods = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.rbac.options.gloo.solo.io.Permissions.prototype.clearMethodsList = function() {
  this.setMethodsList([]);
};


goog.object.extend(exports, proto.rbac.options.gloo.solo.io);
